@if (readonly()) {
    <tran-application-requesters [requesters]="peopleList()" [label]="label() | translate" />
} @else {
    @if (control(); as control) {
        <si-form-item [label]="label() | translate">
            <tran-people-select [multi]="multi()" [control]="control" />
        </si-form-item>
    }
}
